// ドライバーの状態の表示（仕様書「ドライバーの状況」の状態とバッジの色）
import { RULES, type DriverState, type DriverStatusRow } from '@torapon/shared';

export const STATE: Record<DriverState, [label: string, pill: string]> = {
  off: ['勤務前', ''], rollcall_waiting: ['点呼の確認待ち', 'warn'], standby: ['待機中', 'ok'], unaccepted: ['依頼の受付待ち', 'warn'],
  to_pickup: ['ピックアップ先へ', 'dark'], to_drop: ['ドロップ先へ', 'dark'], on_break: ['休憩中', ''], unknown_stop: ['理由不明の停車', 'ng'], no_signal: ['通信なし', 'ng'], ended: ['勤務終了', ''],
};

/** 注意の印（電池 20% 以下・通信なし・マナーモード） */
/** 勤務中の人だけに出す（勤務外の端末の状態は気にしない） */
export function cautions(r: DriverStatusRow): string[] {
  const out: string[] = [];
  if (!r.shiftId) return out;
  if (r.state === 'no_signal') out.push('通信なし');
  if (r.device?.battery != null && r.device.battery <= RULES.lowBatteryPct && !r.device.charging) out.push(`電池 ${r.device.battery}%`);
  if (r.device?.silent) out.push('マナーモード');
  return out;
}

/** 注意が必要な順（既定の並び）：通信なし → 受付待ち・点呼待ち → 注意の印あり → 配送中 → 待機 → 勤務外 */
const RANK: Record<DriverState, number> = { no_signal: 0, unknown_stop: 0, unaccepted: 1, rollcall_waiting: 1, to_pickup: 3, to_drop: 3, on_break: 4, standby: 4, ended: 5, off: 6 };
export const attention = (r: DriverStatusRow) => RANK[r.state] - (cautions(r).length && RANK[r.state] > 1 ? 1 : 0);

export const ago = (iso: string | null | undefined, now = Date.now()) => {
  if (!iso) return '';
  const s = Math.max(0, Math.floor((now - Date.parse(iso)) / 1000));
  return s < 60 ? `${s} 秒前` : s < 3600 ? `${Math.floor(s / 60)} 分前` : `${Math.floor(s / 3600)} 時間 ${Math.floor((s % 3600) / 60)} 分前`;
};
export const hm = (min: number | null) => (min === null ? '—' : `${Math.floor(min / 60)}:${String(min % 60).padStart(2, '0')}`);
